<template>
  <v-container fluid>
    <v-form id="bug-form" v-model="valid" ref="form" class="wrapper lg mx-auto pa-4 mt-4">
      <v-alert type="success" :value="success">
        Product Request Submitted
      </v-alert>
      <v-alert type="error" :value="error">
        Failed to Submit Product Request
      </v-alert>
      <v-layout row wrap>
        <v-flex xs6 pa-3>
          <v-text-field
               label="Your Name"
               v-model="user.name"
               disabled
               class="input-group--focused"
               ></v-text-field>
        </v-flex>
        <v-flex xs6 pa-3> <v-text-field
               label="Your E-mail"
               v-model="user.email"
               disabled
               ></v-text-field>
        </v-flex>
        <v-flex xs6 pa-3>
          <v-text-field
               label="Your Department"
               v-model="department"
               :rules="departmentRules"
               required
               ></v-text-field>
        </v-flex>
        <v-flex xs6 pa-3> <v-text-field label="Manager or Team Lead"
               v-model="businessOwner"
               :rules="businessOwnerRules"
               required
               ></v-text-field>
        </v-flex>
        <v-flex xs6 pa-3>
          <v-text-field
               label="Other Stakeholders"
               v-model="otherStakeholders"
               ></v-text-field>
        </v-flex>
        <v-flex xs6 pa-3>
          <v-text-field
               label="Target Live Date"
               v-model="targetDate"
               ></v-text-field>
        </v-flex>
        <v-flex xs6 pa-3>
          <v-radio-group v-model="product" label="Product" row required>
            <v-layout pt-1>
              <v-radio label="TH" value="TH" ></v-radio>
              <v-radio label="HE" value="HE"></v-radio>
            </v-layout>
          </v-radio-group>
        </v-flex>
        <v-flex xs6 pa-3>
          <v-radio-group v-model="requestType" label="Type of Request" row required>
            <v-layout pt-1>
              <v-radio label="Existing Feature" value="Existing Feature" ></v-radio>
              <v-radio label="New Feature" value="New Feature"></v-radio>
            </v-layout>
          </v-radio-group>
        </v-flex>
        <v-flex xs6 pa-3>
          <v-radio-group v-model="urgency" label="Urgency" row required>
            <v-layout pt-1>
              <v-radio label="High" value="High" ></v-radio>
              <v-radio label="Medium" value="Medium"></v-radio>
              <v-radio label="Low" value="Low"></v-radio>
            </v-layout>
          </v-radio-group>
        </v-flex>
        <v-flex xs12 pa-3>
          <v-text-field v-model="overview"
                        label="Product Request Overview"
                        value="Input text"
                        class="input-group"
                        required
                        multi-line
                        ></v-text-field>
        </v-flex>
        <v-flex xs12 pa-3>
          <v-text-field v-model="businessProblem"
                        label="Business Problem to Solve"
                        value="Input text"
                        class="input-group"
                        required
                        multi-line
                        ></v-text-field>
        </v-flex>
        <v-flex xs12 pa-3>
          <v-text-field v-model="customersImpacted"
                        label="Customer(s) Impacted"
                        value="Input text"
                        class="input-group"
                        required
                        multi-line
                        ></v-text-field>
        </v-flex>
        <v-flex xs12 pa-3>
          <v-text-field v-model="knownDependencies"
                        label="Known Dependencies"
                        value="Input text"
                        class="input-group"
                        required
                        multi-line
                        ></v-text-field>
        </v-flex>
        <v-flex xs12 pa-3>
          <v-text-field v-model="userJourney"
                        label="User Journey"
                        value="Input text"
                        class="input-group"
                        required
                        multi-line
                        ></v-text-field>
        </v-flex>
        <v-flex xs12 pa-3>
          <v-text-field v-model="returnValueToCompany"
                        label="Value to Company"
                        value="Input text"
                        class="input-group"
                        required
                        multi-line
                        ></v-text-field>
        </v-flex>
        <v-flex xs12 pa-3 mt-4 mb-4>
          <v-layout column pa-5 id="file-upload" class="wrapper md mx-auto pa-5 my-4" v-bind:class="{valid: images.length}">
            <v-flex mx-auto>
              <span class="title">Upload Screenshots</span>
            </v-flex>
            <v-flex mx-auto pt-4 pb-4>
              <label for="file" class="mx-auto">
                <v-icon class="pa-4"></v-icon>
              </label>
              <input @change="processFile($event)" type="file" name="file" id="file" accept="image/*" multiple>
            </v-flex>
            <transition name="fade" v-for="(image, index) in images" :key="index">
            <v-flex xs10 pa-3 mx-auto v-show="image" >
              <img :src="image">
            </v-flex>
            </transition>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row>
        <div class="controls">
          <v-btn
             @click="submit"
             :disabled="!valid"
             color="success"
             >
             submit
          </v-btn>
            <v-btn @click="clear">clear</v-btn>
        </div>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';

export default {
  name: 'ProductRequestForm',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      success: false,
      error: false,
      valid: false,
      images: [],
      department: '',
      departmentRules: [v => !!v || 'Department is required'],
      businessOwner: '',
      businessOwnerRules: [v => !!v || 'Business Owner is required'],
      otherStakeholders: '',
      product: '',
      requestType: '',
      urgency: '',
      targetDate: '',
      overview: '',
      businessProblem: '',
      customersImpacted: '',
      knownDependencies: '',
      userJourney: '',
      returnValueToCompany: ''
    };
  },
  computed: mapState({
    ...mapState('account', ['user'])
  }),
  methods: {
    ...mapActions({
      successAlert: 'alert/success',
      errorAlert: 'alert/error'
    }),
    processFile(event) {
      this.file = event.target.files[0];
      this.onFileChange(event);
    },
    submit() {
      if (this.$refs.form.validate()) {
        axios
          .post(`${process.env.BASE_URL}/submissions/product-request`, {
            name: this.user.name,
            email: this.user.email,
            department: this.department,
            businessOwner: this.businessOwner,
            otherStakeholders: this.otherStakeholders,
            product: this.product,
            requestType: this.requestType,
            urgency: this.urgency,
            targetDate: this.targetDate,
            overview: this.overview,
            businessProblem: this.businessProblem,
            customersImpacted: this.customersImpacted,
            knownDependencies: this.knownDependencies,
            userJourney: this.userJourney,
            images: this.images,
            returnValueToCompany: this.returnValueToCompany,
            createdAt: `${new Date().toLocaleDateString()}`
          })
          .then(result => {
            this.$toastr.s('Product request submitted');
            this.$router.go();
          })
          .catch((err) => {
            this.$toastr.e(`Failed to submit product request ${err}`);
          });
      }
    },
    clear() {
      this.$refs.form.reset();
      this.images = [];
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      Array.from(files).forEach(file => this.createImage(file));
    },
    createImage(file) {
      this.file = event.target.files[0];
      var reader = new FileReader();
      var vm = this;

      reader.onload = e => {
        vm.images.push(e.target.result);
      };
      reader.readAsDataURL(file);
    },
    removeImage: function(e) {
      e.preventDefault();
      e.target.value = '';
    }
  }
};
</script>

<style lang="scss">
@import "./../style/_variables.scss";

#bug-form {
  background-color: $white;
}

#file-upload {
  background-color: $light-gray;
  border: 2px dashed $gray;

  img {
    width: 100%;
  }

  input {
    display: none;
  }

  label {
    background-color: $primary;
    border-radius: 50%;
    box-shadow: $box-shadow-light;
    color: $white;
    cursor: pointer;
    display: block;
    transition: 0.4s all ease-out;

    i {
      color: $white;

      &:before {
        content: "add";
      }
    }

    &:hover {
      box-shadow: $box-shadow-dark;
      transform: scale(1.1);
    }
  }

  &.valid {
    label {
      background-color: #0ac775;

      i {
        &:before {
          content: "done";
        }
      }

      &:hover {
        background-color: #f44a4a;

        i:before {
          content: "add";
        }
      }
    }
  }
}

.controls {
  margin-left: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductRequestForm.vue